import { render, staticRenderFns } from "./popNotification.component.vue?vue&type=template&id=e29a6c7c&scoped=true&"
import script from "./popNotification.component.vue?vue&type=script&lang=js&"
export * from "./popNotification.component.vue?vue&type=script&lang=js&"
import style0 from "./popNotification.component.vue?vue&type=style&index=0&id=e29a6c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29a6c7c",
  null
  
)

export default component.exports